import { defineStore } from "pinia";

export const useToast = defineStore("toast", {
  state: (): {
    show: boolean;
    type: "success" | "warning" | "error";
    text: string | undefined;
    duration: number;
    isClosable: boolean;
  } => ({
    show: false,
    type: "success",
    text: undefined,
    duration: 3000,
    isClosable: false,
  }),
  actions: {
    showSuccessToast(message?: string) {
      this.show = true;
      this.type = "success";
      this.text = message;
      this.duration = 2000;
      this.isClosable = false;
    },
    showWarningToast(message: string) {
      this.show = true;
      this.type = "warning";
      this.text = message;
      this.duration = 5000;
      this.isClosable = false;
    },
    showErrorToast(message?: string) {
      this.show = true;
      this.type = "error";
      this.text = message;
      this.duration = 10000;
      this.isClosable = true;
    },
  },
});
